import { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Link } from 'react-router-dom';

import {
  Box,
  Button,
  TextField,
  Typography,
  ThemeProvider,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';

import { generateTheme } from 'utils/helpers';
import { useSetNewPassword } from 'features/reset-password/services/reset-password.service';

import { useStyles } from './reset-password-form.styles';

const ResetPasswordForm = ({ resetToken }) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { control, handleSubmit, watch } = useForm();
  const setNewPassword = useSetNewPassword();
  const classes = useStyles();

  const password = watch('password');

  const onSubmitHandler = data => {
    setNewPassword.mutate(
      { password: data.password, resetToken },
      { onSuccess: () => setIsSuccess(true) },
    );
  };

  return (
    <Box style={{ width: '700px', margin: '0 auto' }}>
      <Typography variant="h1" className={classes.title}>
        Restablecer contraseña
      </Typography>
      <Typography style={{ textAlign: 'center', paddingBottom: '16px' }}>
        Necesitas cambiar tu contraseña para ingresar a tu cuenta
      </Typography>
      <Box pt={2}>
        <form onSubmit={handleSubmit(onSubmitHandler)}>
          <Controller
            name="password"
            defaultValue=""
            control={control}
            rules={{ required: 'Este campo es requerido' }}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
                <TextField
                  fullWidth
                  type={showPassword ? 'text' : 'password'}
                  label="Escribe tu contraseña"
                  variant="outlined"
                  error={!!error}
                  value={value}
                  onChange={onChange}
                  helperText={error ? error.message : ''}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(prev => !prev)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </ThemeProvider>
            )}
          />
          <Box pt={2}>
            <Controller
              name="confirmPassword"
              defaultValue=""
              control={control}
              rules={{
                required: 'Este campo es requerido',
                validate: value =>
                  value === password || 'Las contraseñas no coinciden',
              }}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
                  <TextField
                    fullWidth
                    type={showConfirmPassword ? 'text' : 'password'}
                    label="Confirma tu contraseña"
                    variant="outlined"
                    error={!!error}
                    value={value}
                    onChange={onChange}
                    helperText={error ? error.message : ''}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowConfirmPassword(prev => !prev)}
                            edge="end"
                          >
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </ThemeProvider>
              )}
            />
          </Box>
          {isSuccess && (
            <Box pt={2}>
              <Alert severity="success">
                La contraseña fue actualizada correctamente, ahora puedes
                ingresar de nuevo <Link to="/" style={{ textDecoration: 'underline', color: 'blue', fontWeight: 'bold' }}>aquí</Link>.
              </Alert>
            </Box>
          )}
          <Box pt={2} textAlign="center">
            <Button
              type="submit"
              variant="contained"
              disabled={setNewPassword.isLoading || isSuccess}
              className={classes.button}
            >
              Enviar
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default ResetPasswordForm;
